import "../Styles/Legal.css";
import Footer from "./Footer";
import Header from "./Header";

function PrivacyPolicy() {
  return (
    <>
    <Header/>
 
    <div id="privacy-policy" className="legal">
      <div className="legal-container">
        <h1>Privacy Policy</h1>

        <p className="date">Effective Date: 25 June 2026</p>

        <p>
          Welcome to Cluster Clear. We are committed to protecting your privacy
          and ensuring your personal information is handled securely and
          responsibly.
        </p>

        <h2>Information We Collect</h2>

        <p>
          We may collect your name, email address, contact messages, business
          information, profile information and website analytics.
        </p>

        <h2>How We Use Your Information</h2>

        <p>
          We use your information to provide our services, improve our platform,
          respond to enquiries, communicate updates and maintain security.
        </p>

        <h2>Analytics</h2>

        <p>
          We collect anonymous analytics such as browser type, referral source,
          device information and page visits to improve Cluster Clear.
        </p>

        <h2>Your Rights</h2>

        <p>
          You may request access, correction or deletion of your personal
          information by contacting us.
        </p>

        <h2>Contact</h2>

        <p>support@clusterclear.app</p>
      </div>
    </div>
    <Footer/>
       </>
  );
}

export default PrivacyPolicy;